export function fullMatchTypes(type: string, targets: string[]) {
  if (type === null) { return false; }

  const types = type.split(' ');

  let matched = true;

  while (matched && targets.length) {
    const target = targets.shift() as string;
    matched = types.indexOf(target) > -1;
  }

  return matched;
}

// 判断 obj 对象是否有 key 属性，obj 可使用全大小写
export function includesIgnoreCase(arr: string[], key: string) {
  return !!arr.find(item => {
    return item === key || item.toLowerCase() === key || item.toUpperCase() === key;
  });
}
